/* eslint-disable */
import styles from './index.module.scss'
import { Link } from 'react-router-dom'
import { PageContext } from '../../../../context/PageContextProvider'
import { useContext } from 'react'
import Helper from '../../../../utils/Helper'
import image from '../../../../assets/images/news.jpg'
import translate from '../../../../utils/translate'

const EventCard = ({ img, title, date, event, label, to, bool = false }) => {
  const { language } = useContext(PageContext)

  const active = {
    AZ: 'Aktiv',
    ENG: 'Active',
    RU: 'Активный',
    TR: 'Aktif',
  }
  const outdated = {
    AZ: 'Köhnə',
    ENG: 'Outdated',
    RU: 'Устаревший',
    TR: 'Eski',
  }
  return (
    <Link to={to} className={`${styles.card} bpg-card-neon`}>
      <figure>
        <img
          style={bool ? { objectFit: 'contain' } : null}
          src={img ? img : image}
          alt={title}
        />
        <div>
          {event && <span>{translate[event]?.[language] || translate[event]?.TR || translate[event]?.AZ || (event === 'news' ? 'Xəbər' : event === 'article' ? 'Məqalə' : event === 'post' ? 'Tədbir' : event === 'telim' ? 'Təlim' : event)}</span>}
          <span
            style={
              label === 'Active'
                ? { backgroundColor: '#00D68F' }
                : { backgroundColor: '#FF3D71' }
            }
          >
            {label ? (active[language] || active.TR || active.AZ) : (outdated[language] || outdated.TR || outdated.AZ)}
          </span>
        </div>
      </figure>
      <p>{Helper.textLengthChecker(title, 80)}</p>
      <span>{date}</span>
    </Link>
  )
}

export default EventCard
